import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ConfigSettingsComponent } from './config-settings.component';
import { AddConfigComponent } from './add-config/add-config.component';
import { EditConfigComponent } from './edit-config/edit-config.component';

@NgModule({
  declarations: [ConfigSettingsComponent, AddConfigComponent, EditConfigComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [ConfigSettingsComponent],
})
export class ConfigSettingsModule {}
